import React from 'react';

import { flagStyles } from '../settings';

const SvgVE = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5616px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgVE;
